import { useState } from "react";
import { Api } from "../api/Api";
import { useErrorWebhook } from "./useErrorWebhook";

export const useGetCreditAnalysisDataV2 = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { ErrorWebhookTrigger } = useErrorWebhook();
  const getCreditAnalysisDataV2 = async (
    uuid,
    data,
    message_type,
    additionalData = {}
  ) => {
    setIsLoading(true);
    const response = await Api.post("api/v1/credit_checkV2", {
      uuid,
      data,
      message_type,
      ...additionalData,
    }).catch(function (error) {
      const erroMessage = {
        serviceName: `Credit check - ${message_type}`,
        errorReason: error.message,
        errorCode: error.code,
        uuid: uuid,
      };
      ErrorWebhookTrigger(erroMessage);
      return {
        data: {
          status: "Success",
          error: true,
        },
      };
    });
    setIsLoading(false);
    return response;
  };
  return { getCreditAnalysisDataV2, isLoading };
};
